import { Checkbox as MantineCheckbox } from '@mantine/core';
import classes from './Checkbox.module.css';

type CheckboxProps = {
	checked: boolean;
};

export const Checkbox = ({ checked }: CheckboxProps) => {
	return (
		<MantineCheckbox
			classNames={{
				input: !checked ? classes.checkboxInput : '',
			}}
			radius="xl"
			size="md"
			checked={checked}
			readOnly
		/>
	);
};
